// src/NavBar.js
import { Link } from 'react-router-dom';

function NavBar() {
  return (
    <header className="bg-black text-green-400 border-b border-green-500 py-3">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-2xl font-mono">
          <pre className="whitespace-pre">{/* ASCII Art */}</pre>
          oPiVY<span className="text-blue-400">BBS</span>
        </div>
        <nav>
          <Link to="/" className="nav-button">Home</Link> {/* Home button */}
          <Link to="/forum" className="nav-button">Forum</Link>
          <Link to="/chat" className="nav-button">IRC Chat</Link>
          <Link to="/announcements" className="nav-button">Announcements</Link>
        </nav>
      </div>
    </header>
  );
}

export default NavBar;
